export default "__VITE_ASSET__2865175a__"